import { render } from "./project-type.html?vue&type=template&id=730169e3&scoped=true&ts=true"
import script from "./project-type.ts?vue&type=script&lang=ts"
export * from "./project-type.ts?vue&type=script&lang=ts"

import "./project-type.scss?vue&type=style&index=0&id=730169e3&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730169e3"]])

export default __exports__